export default "__VITE_ASSET__BSej3oJh__"